export default "__VITE_ASSET__CksuBB5G__"